import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Result } from 'antd';
import i18n from "i18next";
import { useSelector } from 'react-redux';
const ErrorPage = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const { errorCode, errorDescription, errorTitle } = state || '';
      const uiState = useSelector((state: any) => state.portal.uiState);
     useEffect(() => {
       console.log("uiState.Language", uiState.Language);
       i18n.changeLanguage(uiState.Language);
     }, []);
    console.log(state);
    return (
        <>
            <Result
                status={errorCode ? errorCode : "warning"}
                title={errorTitle ? errorTitle : t('LANDING.NOTFOUND_DEFAULT_TITLE')}
                subTitle={errorDescription ? errorDescription : t('LANDING.NOTFOUND_DEFAULT')}
            /></>
    )
}
export default ErrorPage;